import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { NAV, SITE } from "@/lib/site";
import { SiteSearch } from "@/components/SiteSearch";
import brandMark from "@/assets/brand-mark.png.asset.json";

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/90 backdrop-blur-xl">
      <div className="container-svg grid grid-cols-[auto_1fr_auto] items-center gap-6 h-[76px]">
        {/* Logo */}
        <Link
          to="/"
          className="group flex items-center gap-3 min-w-0"
          aria-label={`${SITE.name} — Início`}
        >
          <img
            src={brandMark.url}
            alt=""
            width={44}
            height={44}
            className="h-11 w-11 shrink-0 rounded-xl object-contain shadow-[var(--shadow-glow)] ring-1 ring-primary/20 transition-transform group-hover:scale-[1.03]"
          />
          <span className="hidden sm:flex flex-col leading-tight border-l border-border/70 pl-3 whitespace-nowrap">
            <span className="font-display text-[17px] md:text-lg font-extrabold tracking-tight text-foreground">
              Dedetizadora <span className="text-primary">Chapecó</span>
            </span>
            <span className="text-[10px] font-semibold uppercase tracking-[0.22em] text-muted-foreground mt-1">
              Controle de Pragas · SC
            </span>
          </span>
        </Link>

        {/* Nav centralizada */}
        <nav className="hidden lg:flex items-center justify-center gap-0.5" aria-label="Principal">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              activeOptions={n.to === "/" ? { exact: true } : undefined}
              activeProps={{ className: "text-primary bg-primary/10" }}
              inactiveProps={{ className: "text-foreground/75 hover:text-primary hover:bg-primary/5" }}
              className="whitespace-nowrap rounded-lg px-3 py-2 text-[13px] font-semibold tracking-wide leading-none transition-colors"
            >
              {n.label}
            </Link>
          ))}
        </nav>

        {/* Ações direita */}
        <div className="flex items-center gap-2 justify-end">
          <a
            href={SITE.whatsappUrl}
            target="_blank"
            rel="noopener"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-xs font-semibold uppercase tracking-wide text-primary-foreground shadow-[var(--shadow-glow)] hover:brightness-110 transition whitespace-nowrap"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
              <path d="M20.5 3.5A11.9 11.9 0 0 0 12 0C5.4 0 0 5.4 0 12c0 2.1.6 4.2 1.7 6L0 24l6.2-1.6A11.9 11.9 0 0 0 12 24c6.6 0 12-5.4 12-12 0-3.2-1.3-6.2-3.5-8.5zM12 22a10 10 0 0 1-5.1-1.4l-.4-.2-3.7 1 1-3.6-.2-.4A10 10 0 1 1 22 12c0 5.5-4.5 10-10 10z"/>
            </svg>
            Orçamento
          </a>
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-border bg-background text-foreground hover:border-primary hover:text-primary transition-colors"
            aria-label="Abrir menu"
            aria-expanded={open}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden>
              {open ? <path d="M6 6l12 12M6 18L18 6" /> : <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>}
            </svg>
          </button>
        </div>
      </div>

      {/* Barra de pesquisa em linha própria (desktop) */}
      <div className="hidden md:block border-t border-border/60 bg-background/70">
        <div className="container-svg py-2.5">
          <div className="mx-auto max-w-xl">
            <SiteSearch compact />
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <nav className="container-svg flex flex-col py-3 gap-1" aria-label="Menu mobile">
            <div className="mb-2 md:hidden"><SiteSearch compact /></div>
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                activeOptions={{ exact: n.to === "/" }}
                activeProps={{ className: "text-primary bg-primary/10" }}
                inactiveProps={{ className: "text-foreground/80 hover:text-primary hover:bg-primary/5" }}
                className="rounded-lg px-3 py-3 text-sm font-semibold tracking-wide transition-colors"
              >
                {n.label}
              </Link>
            ))}
            <a
              href={SITE.whatsappUrl}
              target="_blank"
              rel="noopener"
              onClick={() => setOpen(false)}
              className="mt-3 w-full inline-flex justify-center rounded-full bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground shadow-[var(--shadow-glow)]"
            >
              Orçamento no WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
